import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-1 -1 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.0759 0H10.9241C4.8909 0 0 4.8909 0 10.9241V11.0759C0 17.1091 4.8909 22 10.9241 22H11.0759C17.1091 22 22 17.1091 22 11.0759V10.9241C22 4.8909 17.1091 0 11.0759 0Z",
		fill: "#D0D0DA"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.9996 8.55583C11.6746 8.55583 12.2218 9.10303 12.2218 9.77805V15.8892C12.2218 16.5642 11.6746 17.1114 10.9996 17.1114C10.3246 17.1114 9.77734 16.5642 9.77734 15.8892V9.77805C9.77734 9.10304 10.3246 8.55583 10.9996 8.55583ZM10.9996 4.88916C11.6746 4.88916 12.2218 5.43637 12.2218 6.11138C12.2218 6.7864 11.6746 7.33361 10.9996 7.33361C10.3246 7.33361 9.77734 6.7864 9.77734 6.11138C9.77734 5.43637 10.3246 4.88916 10.9996 4.88916Z",
		fill: "white"
	})]
});
export default SvgInfo;
